import { Grid } from '@mui/material';
import { useState } from 'react';
import { MuiPopup } from '../molecules/popupComponent';
import { MuiImagePopUp } from './imageDialogBox';
export default function ViewAllImagePopUp(props) {
    var isOpen = props.isOpen, onClosed = props.onClosed, images = props.images;
    var _a = useState(null), isDrawerOpen = _a[0], setISDrawerOpen = _a[1];
    var handleClickImage = function (photoIndex) {
        setISDrawerOpen(photoIndex);
    };
    var handleClose = function (photoIndex) {
        setISDrawerOpen(null);
    };
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: isOpen,
        title: "View All Images",
        onClose: onClosed,
        closeIcon: true,
        containerStyle: {
            width: '100%',
            padding: '2px 5px 8px 5px'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        alignItems: "center",
        spacing: 1
    }, images === null || images === void 0 ? void 0 : images.map(function (image, index) { /*#__PURE__*/ return React.createElement(Grid, {
        item: true,
        key: index + 1,
        xs: 4,
        sm: 4,
        md: 4,
        lg: 4,
        style: {
            display: 'flex',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'relative'
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: image.images ? image.images : image.blobUrl,
        alt: "Image ".concat(index + 1),
        style: {
            width: '100px',
            height: '100px',
            borderRadius: '8px',
            position: 'relative'
        },
        onClick: function () { return handleClickImage(index); }
    })), isDrawerOpen !== null && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: index == isDrawerOpen ? true : false,
        onClose: handleClose,
        image: image.images ? image.images : image.blobUrl
    })); })));
}
